import { render } from "./manage-developmentblocks.vue?vue&type=template&id=d5c1c23e"
import script from "./manage-developmentblocks.vue?vue&type=script&lang=js"
export * from "./manage-developmentblocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/workorganisation/manage-developmentblocks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5c1c23e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5c1c23e', __exports__)) {
    api.reload('d5c1c23e', __exports__)
  }
  
  module.hot.accept("./manage-developmentblocks.vue?vue&type=template&id=d5c1c23e", () => {
    api.rerender('d5c1c23e', render)
  })

}


export default __exports__